import * as z from "zod";

import { PartnerSummarySchema } from "../shared/partner";

export const verifyMagicLink = {
  name: "verifyMagicLink" as const,
  input: z.object({ token: z.string().min(1).max(4096) }),
  output: z.object({
    partner: PartnerSummarySchema,
    authToken: z.string().min(1),
  }),
};
